import { render, staticRenderFns } from "./packge.vue?vue&type=template&id=3dc5b3b0&scoped=true&"
import script from "./packge.vue?vue&type=script&lang=js&"
export * from "./packge.vue?vue&type=script&lang=js&"
import style0 from "./packge.vue?vue&type=style&index=0&id=3dc5b3b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5b3b0",
  null
  
)

export default component.exports